// SEFIL 360 Landing Page Mock Data

export const SITE_CONFIG = {
  name: "SEFIL 360",
  tagline: "The Modern Student Information Management System",
  description:
    "Effortlessly manage student records across pre-primary, primary, junior-secondary, and secondary schools in Kenya with our comprehensive, intuitive platform.",
  dashboardUrl: "https://app.sefil360.com",
  signupFormUrl:
    "https://docs.google.com/forms/d/e/1FAIpQLSfvzdG169scce0MHltwC9zlOA4ZJwniOLxw0BzZfi8qVi_3rw/viewform?usp=publish-editor",
  domain: "sefil360.com",
};

export const FEATURES = [
  {
    id: 1,
    icon: "GraduationCap",
    title: "Grade Management",
    description:
      "Comprehensive grading system supporting CBC, 8-4-4, and IGCSE curricula. Track student performance with customizable assessment rubrics and automatic grade calculations.",
  },
  {
    id: 2,
    icon: "FileText",
    title: "Report Cards",
    description:
      "Generate professional, customizable report cards instantly. Supports multiple formats aligned with Kenyan education standards and CBC competency-based assessments.",
  },
  {
    id: 3,
    icon: "Wallet",
    title: "Fee Management",
    description:
      "Streamline fee collection with automated invoicing, payment tracking, and M-Pesa integration. Send payment reminders and generate financial reports effortlessly.",
  },
  {
    id: 4,
    icon: "BookOpen",
    title: "Library Management",
    description:
      "Digitize your school library with barcode scanning, book tracking, and automated overdue notifications. Manage lending, returns, and inventory with ease.",
  },
  {
    id: 5,
    icon: "HeartPulse",
    title: "Student Health Records",
    description:
      "Maintain comprehensive health records including immunizations, medical history, allergies, and emergency contacts. Ensure student safety and wellness tracking.",
  },
  {
    id: 6,
    icon: "Calendar",
    title: "Timetable Management",
    description:
      "Create and manage class schedules with conflict detection. Automatic timetable generation, room allocation, and teacher assignment optimization.",
  },
  {
    id: 7,
    icon: "MessageSquare",
    title: "Bulk SMS Notifications",
    description:
      "Keep parents informed with instant bulk SMS notifications. Send fee reminders, event announcements, emergency alerts, and academic updates directly to phones.",
  },
  {
    id: 8,
    icon: "BarChart3",
    title: "Powerful Analytics",
    description:
      "Data-driven insights with comprehensive dashboards. Track enrollment trends, academic performance, attendance patterns, and financial metrics at a glance.",
  },
];

export const PRICING = {
  perStudentCost: 120, // 120 KES per student per year
  currency: "KES",
  billingPeriod: "year",
  plans: [
    {
      id: "starter",
      name: "Starter",
      students: 100,
      price: 12000, // 100 students × 120 KES
      features: [
        "Up to 100 students",
        "Grade management",
        "Report cards",
        "Fee management",
        "Basic SMS (100/month)",
        "Email support",
      ],
      popular: false,
    },
    {
      id: "standard",
      name: "Standard",
      students: 300,
      price: 36000, // 300 students × 120 KES
      features: [
        "Up to 300 students",
        "All Starter features",
        "Library management",
        "Timetable management",
        "Bulk SMS (500/month)",
        "Health records",
        "Priority support",
      ],
      popular: true,
    },
    {
      id: "premium",
      name: "Premium",
      students: 600,
      price: 72000, // 600 students × 120 KES
      features: [
        "Up to 600 students",
        "All Standard features",
        "Advanced analytics",
        "Unlimited SMS",
        "Custom reports",
        "API access",
        "Dedicated support",
        "Training sessions",
      ],
      popular: false,
    },
  ],
  enterprise: {
    name: "Enterprise",
    description: "For large school groups and county-wide deployments",
    features: [
      "Unlimited students",
      "Multi-school management",
      "Custom integrations",
      "On-premise option",
      "SLA guarantee",
      "24/7 support",
    ],
  },
};

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Sarah Wanjiku",
    role: "Principal",
    school: "Greenfields Academy, Nairobi",
    content:
      "SEFIL 360 transformed how we manage our school. Report card generation that used to take days now takes minutes. Parents love receiving instant SMS updates about their children.",
    avatar: "SW",
  },
  {
    id: 2,
    name: "James Ochieng",
    role: "School Administrator",
    school: "St. Peters Primary, Kisumu",
    content:
      "The fee management module has reduced our outstanding balances by 40%. The M-Pesa integration makes it so easy for parents to pay, and we can track everything in real-time.",
    avatar: "JO",
  },
  {
    id: 3,
    name: "Mary Muthoni",
    role: "Deputy Head Teacher",
    school: "Sunrise Junior Secondary, Nakuru",
    content:
      "Transitioning to CBC was seamless with SEFIL 360. The competency-based assessment tools and report formats are exactly what we needed. Highly recommended!",
    avatar: "MM",
  },
  {
    id: 4,
    name: "Peter Kimani",
    role: "IT Coordinator",
    school: "Excellence High School, Mombasa",
    content:
      "As someone who manages technology for our school, I appreciate how user-friendly SEFIL 360 is. Teachers picked it up quickly, and the support team is always responsive.",
    avatar: "PK",
  },
];

export const FAQ = [
  {
    id: 1,
    question: "What school levels does SEFIL 360 support?",
    answer:
      "SEFIL 360 supports all levels of education in Kenya including pre-primary (PP1 & PP2), primary (Grade 1-6), junior secondary (Grade 7-9), and senior secondary (Grade 10-12). Our system is fully aligned with both the CBC and 8-4-4 curricula.",
  },
  {
    id: 2,
    question: "How does the pricing work?",
    answer:
      "Our pricing is simple and transparent — just KES 120 per student per year. This means a school with 100 students pays only KES 12,000 annually. This affordable rate ensures schools of all sizes can access quality management tools.",
  },
  {
    id: 3,
    question: "Can parents access the system?",
    answer:
      "Yes! Parents can access a dedicated portal to view their children's grades, attendance, fee balances, and receive notifications. They can also communicate with teachers through the platform.",
  },
  {
    id: 4,
    question: "Is my data secure?",
    answer:
      "Absolutely. We use bank-level encryption (256-bit SSL) for all data transmission. Your data is stored in secure, redundant servers with daily backups. We comply with Kenya's Data Protection Act and international data privacy standards.",
  },
  {
    id: 5,
    question: "Do you offer training and support?",
    answer:
      "Yes, we provide comprehensive onboarding training for your staff. Our support team is available via phone, email, and WhatsApp during business hours. Premium and Enterprise plans include dedicated support representatives.",
  },
  {
    id: 6,
    question: "Can I migrate data from my current system?",
    answer:
      "We offer free data migration assistance. Our team will help you import student records, grades, and other data from Excel spreadsheets or other school management systems you may be using.",
  },
  {
    id: 7,
    question: "Does it work offline?",
    answer:
      "SEFIL 360 is cloud-based for real-time sync and accessibility. However, our mobile app allows teachers to record attendance and grades offline, which syncs automatically when internet is available.",
  },
];

export const CONTACT = {
  email: "hello@sefil360.com",
  phone: "+254 106 113 456",
  address: "Nairobi, Kenya",
  social: {
    twitter: "https://twitter.com/sefil360",
    facebook: "https://facebook.com/sefil360",
    linkedin: "https://linkedin.com/company/sefil360",
  },
};

export const STATS = [
  { label: "Schools", value: "500+" },
  { label: "Students Managed", value: "150K+" },
  { label: "Counties", value: "35" },
  { label: "Uptime", value: "99.9%" },
];
